import { Box, Button, styled, useTheme } from "@mui/material";
import { DeleteFour, Edit } from "assets/Icon";

function WrapperAction({ handleEdit, handleDelete, data }) {
  const theme = useTheme();

  return (
    <Box display={"flex"} gap={"2px"}>
      <ButtonStyle onClick={() => handleEdit(data)}>
        <Edit color={theme.mode === "info" ? theme.palette.common.black : theme.palette.text.main} />
      </ButtonStyle>

      <ButtonStyleError onClick={() => handleDelete(data)}>
        <DeleteFour color={theme.palette.error.main} />
      </ButtonStyleError>
    </Box>
  );
}

const ButtonStyle = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  minHeight: "auto !important",
  padding: theme.spacing(1),
  "ion-icon": {
    fontSize: "20px",
  },
}));

const ButtonStyleError = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  minHeight: "auto !important",
  padding: theme.spacing(1),

  "ion-icon": {
    fontSize: "20px",
    color: theme.palette.error.main,
  },
}));
export default WrapperAction;
